import http from "../core/http";
const group = 'reports';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/cases`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getAirlinesListRequest =  async (data) => {
    return await http.post(`${group}/getAirlines`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportDataRequest =  async (data) => {
    return await http({url: `${group}/casesExport`, method: "POST", data: data, responseType: "blob"}).then(res => res.data).catch(http.defaultCatch);
}

export const viewFlightRequest = async (data) => {
    return await http.post(`${group}/flightReport`, data).then(res => res.data).catch(http.defaultCatch);
}
export const exportFlightRequest = async (data) => {
    return await http({url: `${group}/flightExport`, method: "POST", data: data, responseType: "blob"}).then(res => res.data).catch(http.defaultCatch);
}
export const mailFlightRequest = async (data) => {
    return await http.post(`${group}/flightMail`, data).then(res => res.data).catch(http.defaultCatch);
}